export default "__VITE_ASSET__CyiZAVxW__"